var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkBlueRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.22,
    height: 51.221,
    viewBox: "0 0 51.22 51.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7712",
    "data-name": "Rectangle 7712",
    width: 36.218,
    height: 36.218,
    rx: 10,
    transform: "translate(0 25.61) rotate(-45)",
    fill: "#3f9fb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBlueRectangle);
export default __webpack_public_path__ + "static/media/darkBlueRectangle.39b953a1542403d46dc994054bf091c7.svg";
export { ForwardRef as ReactComponent };